import type { MealId } from '../validators/meals';

/**
 * Configured meals have one slot per diary date. All automatic producers must
 * use the same identity so independently generated offline copies merge as
 * edits to that slot. Existing and manually added meals retain their own IDs.
 */
export const configuredMealPlanId = (date: string, mealId: MealId): string =>
  `configured-meal:${date}:${mealId}`;
